// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TrainingReportPdf .Table {
  display: block;
  font-size: 12px;
  font-weight: 500;
}
.TrainingReportPdf .Table table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.TrainingReportPdf .Table table .Table-Start,
.TrainingReportPdf .Table table .Table-End {
  display: none;
}
.TrainingReportPdf .Table table .Table-Head {
  display: table-header-group !important;
  position: static;
}
.TrainingReportPdf .Table table .TableRow {
  display: table-row;
  box-shadow: none !important;
}
.TrainingReportPdf .Table table .TableRow:hover:after {
  display: none !important;
}
.TrainingReportPdf .Table table .TableRow .TableCell {
  display: table-cell;
  padding: 12px;
  border-top: 1px solid var(--training-border);
  vertical-align: middle;
}
.TrainingReportPdf .Table table .TableRow .TableCell .TableCell-Content {
  display: block;
  min-height: 0;
  padding: 0;
  overflow: visible;
  white-space: normal;
  font-weight: inherit;
}
.TrainingReportPdf .Table table .TableRow .TableCell:first-child .TableCell-Content, .TrainingReportPdf .Table table .TableRow .TableCell:last-child .TableCell-Content {
  padding: 0;
}
.TrainingReportPdf .Table table .TableRow .TableCell[data-placeholder] .TableCell-Content:empty:before {
  color: inherit;
}
.TrainingReportPdf .Table table .TableRow.TableRow-Header .TableCell {
  background-color: var(--training-navy);
  color: #ffffff;
  line-height: 1.2;
  padding: 0.5rem 12px;
  border-top: none;
}
.TrainingReportPdf .Table table .TableRow.TableRow-Header .TableCell .TableCell-Content {
  font-weight: 800;
  text-transform: uppercase;
}
.TrainingReportPdf .TrainingReportPdf-Table {
  border: 1px solid var(--training-border);
  border-radius: 10px;
  overflow: hidden;
}
.TrainingReportPdf .TrainingReportPdf-Table > table > .Table-Head .TableCell {
  height: 52px;
}
.TrainingReportPdf .TrainingReportPdf-Table > table > .Table-Head .TableCell:first-child {
  border-top-left-radius: 10px;
}
.TrainingReportPdf .TrainingReportPdf-Table > table > .Table-Head .TableCell:last-child {
  border-top-right-radius: 10px;
}
.TrainingReportPdf .TrainingReportPdf-Table > table > .Table-Body > .TrainingReportPdf-CityRow {
  break-inside: avoid;
  break-after: avoid;
}
.TrainingReportPdf .TrainingReportPdf-Table > table > .Table-Body > .TrainingReportPdf-CityRow > .TableCell {
  height: 40px;
  background-color: #f9f6f4;
}
.TrainingReportPdf .TrainingReportPdf-Table > table > .Table-Body > .TrainingReportPdf-DriversRow > .TableCell {
  padding: 16px 12px;
  border-top: none;
  box-decoration-break: clone;
  -webkit-box-decoration-break: clone;
}
.TrainingReportPdf .TrainingReportPdf-DriversTable {
  border: 1px solid var(--training-border);
  border-radius: 10px;
  overflow: hidden;
}
.TrainingReportPdf .TrainingReportPdf-DriversTable .TableCell {
  height: 44px;
}
.TrainingReportPdf .TrainingReportPdf-DriversTable .TableRow {
  break-inside: avoid;
}
.TrainingReportPdf .TrainingReportPdf-DriversTable .StatusCell {
  font-family: "Raleway", sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.4;
  border-radius: 10px;
  padding: 1px 10px 2px 10px;
}
.TrainingReportPdf .TrainingReportPdf-DriversTable .ProgressBarCell .ProgressBarCell-Bar {
  flex: 0 0 91px;
}
.TrainingReportPdf .TrainingReportPdf-DriversTable .ProgressBarCell .ProgressBarCell-Bar .progress {
  height: 8px;
  border-radius: 4px;
  background-color: #e2e8f1;
}
.TrainingReportPdf .TrainingReportPdf-DriversTable .ProgressBarCell .ProgressBarCell-Bar .progress-bar {
  border-radius: 4px;
}
.TrainingReportPdf .TrainingReportPdf-DriversTable .ProgressBarCell .ProgressBarCell-Label {
  font-size: 12px;
  font-weight: 500;
}
.TrainingReportPdf .TrainingReportPdf-DriversTable .TableRow:has(+ .TrainingReportPdf-EvaluatorsRow) {
  break-after: avoid;
}
.TrainingReportPdf .TrainingReportPdf-DriversTable .TrainingReportPdf-EvaluatorsRow > .TableCell {
  height: auto;
  padding: 0;
  background-color: #f8f8f8;
}
.TrainingReportPdf .TrainingReportPdf-Evaluators {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #838383;
}
.TrainingReportPdf .TrainingReportPdf-Evaluators > span {
  padding: 0.25rem 1rem;
  overflow-wrap: break-word;
}
.TrainingReportPdf .TrainingReportPdf-Evaluators > span:nth-child(3n+1) {
  grid-column-start: 2;
}`, "",{"version":3,"sources":["webpack://./src/features/PdfLayout/layouts/TrainingReport/TrainingReportPdfTable/styles.scss"],"names":[],"mappings":"AACE;EACE,cAAA;EACA,eAAA;EACA,gBAAA;AAAJ;AACI;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;AACN;AAAM;;EAEE,aAAA;AAER;AAAM;EACE,sCAAA;EACA,gBAAA;AAER;AAAM;EACE,kBAAA;EACA,2BAAA;AAER;AADQ;EACE,wBAAA;AAGV;AADQ;EACE,mBAAA;EACA,aAAA;EACA,4CAAA;EACA,sBAAA;AAGV;AAFU;EACE,cAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,oBAAA;AAIZ;AAAY;EACE,UAAA;AAEd;AACU;EACE,cAAA;AACZ;AAEQ;EACE,sCAAA;EACA,cAAA;EACA,gBAAA;EACA,oBAAA;EACA,gBAAA;AAAV;AACU;EACE,gBAAA;EACA,yBAAA;AACZ;AAME;EACE,wCAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;AAKI;EACE,YAAA;AAHN;AAIM;EACE,4BAAA;AAFR;AAIM;EACE,6BAAA;AAFR;AAMM;EACE,mBAAA;EACA,kBAAA;AAJR;AAKQ;EACE,YAAA;EACA,yBAAA;AAHV;AAMM;EACE,kBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mCAAA;AAJR;AASE;EACE,wCAAA;EACA,mBAAA;EACA,gBAAA;AAPJ;AAQI;EACE,YAAA;AANN;AAQI;EACE,mBAAA;AANN;AAQI;EACE,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;AANN;AASM;EACE,cAAA;AAPR;AAQQ;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;AANV;AAQQ;EACE,kBAAA;AANV;AASM;EACE,eAAA;EACA,gBAAA;AAPR;AAUI;EACE,kBAAA;AARN;AAUI;EACE,YAAA;EACA,UAAA;EACA,yBAAA;AARN;AAYE;EACE,aAAA;EACA,sCAAA;EACA,iBAAA;EACA,gBAAA;EACA,cAAA;AAVJ;AAWI;EACE,qBAAA;EACA,yBAAA;AATN;AAUM;EACE,oBAAA;AARR","sourcesContent":[".TrainingReportPdf {\n  .Table {\n    display: block;\n    font-size: 12px;\n    font-weight: 500;\n    table {\n      width: 100%;\n      border-collapse: separate;\n      border-spacing: 0;\n      .Table-Start,\n      .Table-End {\n        display: none;\n      }\n      .Table-Head {\n        display: table-header-group !important;\n        position: static;\n      }\n      .TableRow {\n        display: table-row;\n        box-shadow: none !important;\n        &:hover:after {\n          display: none !important;\n        }\n        .TableCell {\n          display: table-cell;\n          padding: 12px;\n          border-top: 1px solid var(--training-border);\n          vertical-align: middle;\n          .TableCell-Content {\n            display: block;\n            min-height: 0;\n            padding: 0;\n            overflow: visible;\n            white-space: normal;\n            font-weight: inherit;\n          }\n          &:first-child,\n          &:last-child {\n            .TableCell-Content {\n              padding: 0;\n            }\n          }\n          &[data-placeholder] .TableCell-Content:empty:before {\n            color: inherit;\n          }\n        }\n        &.TableRow-Header .TableCell {\n          background-color: var(--training-navy);\n          color: #ffffff;\n          line-height: 1.2;\n          padding: 0.5rem 12px;\n          border-top: none;\n          .TableCell-Content {\n            font-weight: 800;\n            text-transform: uppercase;\n          }\n        }\n      }\n    }\n  }\n\n  .TrainingReportPdf-Table {\n    border: 1px solid var(--training-border);\n    border-radius: 10px;\n    overflow: hidden;\n    > table > .Table-Head .TableCell {\n      height: 52px;\n      &:first-child {\n        border-top-left-radius: 10px;\n      }\n      &:last-child {\n        border-top-right-radius: 10px;\n      }\n    }\n    > table > .Table-Body {\n      > .TrainingReportPdf-CityRow {\n        break-inside: avoid;\n        break-after: avoid;\n        > .TableCell {\n          height: 40px;\n          background-color: #f9f6f4;\n        }\n      }\n      > .TrainingReportPdf-DriversRow > .TableCell {\n        padding: 16px 12px;\n        border-top: none;\n        box-decoration-break: clone;\n        -webkit-box-decoration-break: clone;\n      }\n    }\n  }\n\n  .TrainingReportPdf-DriversTable {\n    border: 1px solid var(--training-border);\n    border-radius: 10px;\n    overflow: hidden;\n    .TableCell {\n      height: 44px;\n    }\n    .TableRow {\n      break-inside: avoid;\n    }\n    .StatusCell {\n      font-family: 'Raleway', sans-serif;\n      font-size: 12px;\n      font-weight: 700;\n      line-height: 1.4;\n      border-radius: 10px;\n      padding: 1px 10px 2px 10px;\n    }\n    .ProgressBarCell {\n      .ProgressBarCell-Bar {\n        flex: 0 0 91px;\n        .progress {\n          height: 8px;\n          border-radius: 4px;\n          background-color: #e2e8f1;\n        }\n        .progress-bar {\n          border-radius: 4px;\n        }\n      }\n      .ProgressBarCell-Label {\n        font-size: 12px;\n        font-weight: 500;\n      }\n    }\n    .TableRow:has(+ .TrainingReportPdf-EvaluatorsRow) {\n      break-after: avoid;\n    }\n    .TrainingReportPdf-EvaluatorsRow > .TableCell {\n      height: auto;\n      padding: 0;\n      background-color: #f8f8f8;\n    }\n  }\n\n  .TrainingReportPdf-Evaluators {\n    display: grid;\n    grid-template-columns: 2fr 1fr 1fr 1fr;\n    font-size: 0.9rem;\n    line-height: 1.5;\n    color: #838383;\n    > span {\n      padding: 0.25rem 1rem;\n      overflow-wrap: break-word;\n      &:nth-child(3n + 1) {\n        grid-column-start: 2;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
